/**
 * Post message service
 */
import { Injectable } from '@angular/core';

import { TokenSessionService } from '../session/token-session.service';

@Injectable()
export class PostMessageService {
  public platform: string = 'XEA';
  public portalPlatform: string = 'XPOS';
  public constructor(public tokenSessionService: TokenSessionService) {}

  public sendMessage(message): void {
    // Fix wrong option name and property reading in portal site selector

    this.sendRawMessage(JSON.stringify(message));
  }

  public sendRawMessage(message: string): void {
    parent.postMessage(message, '*');
  }
}
